var map = {
	"./homepage.de-CH.json": 1362,
	"./homepage.de-DE.json": 1363,
	"./homepage.en-CA.json": 1364,
	"./homepage.en-GB.json": 1365,
	"./homepage.en-IN.json": 1366,
	"./homepage.en-ME.json": 1367,
	"./homepage.en-US.json": 1368,
	"./homepage.es-EM.json": 1369,
	"./homepage.es-ES.json": 1370,
	"./homepage.fr-BE.json": 1371,
	"./homepage.fr-CA.json": 1372,
	"./homepage.fr-CH.json": 1373,
	"./homepage.nl-BE.json": 1374,
	"./homepage.nl-NL.json": 1375,
	"./homepage.pl-PL.json": 1376,
	"./homepage.pt-BR.json": 1377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1361;